import { skipToken } from '@apollo/client/react'
import dayjs from 'src/utils/dayjs'
import { getNodesFromConnection } from 'src/utils/graphql'
import { useCheckTokenForArgs } from 'src/utils/token'
import { useMyInfo } from './auth'
import {
  ClaimQuestRewardDocument,
  DailyClaimQuotaDocument,
  FollowSocialMediaDocument,
  GetDailyClaimAvailableDocument,
  ListQuestsDocument,
  WatchSocialMediaLinkDocument,
} from './generated/graphql'
import {
  createMutationHelper,
  createQueryHook,
  createRefetchQueryHelper,
  modifyQueryHook,
} from './utils'

export const useListQuests = modifyQueryHook(
  createQueryHook(ListQuestsDocument),
  {
    reduce: r =>
      r == null
        ? r
        : {
            nodes: getNodesFromConnection(r.quests)
              // This filter logic seems not working on server-side.
              // Re-filter here as a fix.
              .filter(q => {
                if (q.startAt && dayjs(q.startAt).isAfter(dayjs())) return false
                if (q.endAt && dayjs(q.endAt).isBefore(dayjs())) return false
                return true
              }),
            pageInfo: r.quests?.pageInfo,
          },
  },
)
export const [useClaimQuestReward, executeClaimQuestReward] =
  createMutationHelper(ClaimQuestRewardDocument)

export const [useFollowSocialMediaMutation] = createMutationHelper(
  FollowSocialMediaDocument,
)

export const [useWatchSocialMediaLink] = createMutationHelper(
  WatchSocialMediaLinkDocument,
)

export const refetchListQuestsDocument =
  createRefetchQueryHelper(ListQuestsDocument)
export const useQuests = (
  vars: Parameters<typeof useListQuests>[0],
  options?: Parameters<typeof useListQuests>[1],
) => {
  const input = useCheckTokenForArgs(vars)
  const res = useListQuests(input ?? skipToken, options)
  return res
}

const useGetDailyClaimAvailable = modifyQueryHook(
  createQueryHook(GetDailyClaimAvailableDocument),
  {
    reduce: r => r?.me,
  },
)
export const useDailyClaimAvailable = (
  options?: Parameters<typeof useGetDailyClaimAvailable>[1],
) => {
  const { data: me } = useMyInfo()
  return useGetDailyClaimAvailable(me ? {} : skipToken, options)
}

export const [useDailyClaimQuota, executeDailyClaimQuota] =
  createMutationHelper(DailyClaimQuotaDocument)
